/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutocompleteList } from '../../models/autocomplete-list';

export interface TagGetTagAutocompleteList$Params {
  keyTagDefinitionId?: string;
  value?: string;
}

export function tagGetTagAutocompleteList(http: HttpClient, rootUrl: string, params?: TagGetTagAutocompleteList$Params, context?: HttpContext): Observable<StrictHttpResponse<AutocompleteList>> {
  const rb = new RequestBuilder(rootUrl, tagGetTagAutocompleteList.PATH, 'get');
  if (params) {
    rb.query('keyTagDefinitionId', params.keyTagDefinitionId, {});
    rb.query('value', params.value, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutocompleteList>;
    })
  );
}

tagGetTagAutocompleteList.PATH = '/tag/autocomplete/list';
